import React from "react";

export default function ValentineFrame1({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 2000 2000"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls1-2{fill:#e98ead}"}</style>
        </defs>
        <path
          d="M1793.45 894.54v877.54H206.55V894.54h405.09v224.15L972 1318.13h65.27L1412.38 1108V894.54Z"
          style={{
            fill: "#fea1bf",
          }}
        />
        <path
          className="cls1-2"
          d="M206.55 894.54h405.09v224.15ZM1793.45 894.54q-190.54 106.73-381.07 213.46V894.54ZM1004.88 1330.33l-798.33 441.76h1586.9ZM1412.38 894.54V592H611.64v302.54H206.55q399.17-333.31 798.33-666.63 394.28 333.33 788.57 666.63Z"
        />
        <path
          d="M1174.56 1243.05c-8.7-23.39-34.11-52.62-70.11-59.36-32.12-6-66.44 7-92.44 33.72-26-26.67-60.32-39.73-92.44-33.72-36 6.74-61.41 36-70.11 59.36-22.81 61.31 41.26 157.49 162.44 235.35h.22c121.18-77.86 185.25-174.04 162.44-235.35Z"
          style={{
            fill: "#3a4f7a",
          }}
        />
        {children}
      </g>
    </svg>
  );
}
